<template>
  <Popup
    :class="['popups', fullScreen ? 'popups-fullScreen' : '']"
    v-model="isShowPop"
    position="bottom"
    :overlay="overlay && isShowPop"
    @click-overlay="closeFn"
    :get-container="container"
  >
    <div :class="['container', fullScreen ? 'fullScreen' : '']">
      <div class="header" v-statusBar="fullScreen && 'marginTop'">
        <h3 class="tit-left" v-if="!fullScreen">{{ title }}</h3>
        <h3 class="tit-middle" v-else>{{ title }}</h3>
        <img class="n-close" @click="closeFn" src="~assets/img/v1/popup-close2.png" v-if="!fullScreen" />
        <img class="close" @click="closeFn" src="~assets/img/v1/popup-black-close.png" v-else />
      </div>
      <div class="content">
        <slot />
      </div>
      <div v-if="$slots.footer">
        <slot name="footer" />
      </div>
      <div v-else-if="showFooter" :class="['footer', isIphoneX && isAdapter ? 'iphoneX' : '']">
        <v-button position="center" type="frame-plus" @click="footerClick">{{ footer || '确定' }}</v-button>
      </div>
    </div>
  </Popup>
</template>

<script>
import { Popup } from '@vivo/shop-ui-h5'
import env from 'utils/clientEnv'

export default {
  name: 'Popups',
  components: {
    Popup
  },
  props: {
    title: String,
    footer: String,
    isShow: Boolean,
    footerType: Number,
    fullScreen: {
      // 是否全屏， true是全屏 false 是半屏
      type: Boolean,
      default: false
    },
    showFooter: {
      // 是否展示底部
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    },
    isAdapter: {
      // 是否做ios底部高度适配 为了兼容现在已有页面自己做的兼容
      type: Boolean,
      default: false
    },
    container: {
      type: String,
      default: ''
    },
    borderBottom: {
      // 底部是否有上边框
      type: Boolean,
      default: true
    }
  },
  computed: {
    // content () {
    //   if (this.showFooter) return [ 'content', 'footerPadding' ]
    //   else return [ 'content', 'noFooterPadding' ]
    // },
    isIphoneX() {
      if (/iphone/gi.test(window.navigator.userAgent)) {
        /* iPhone X、iPhone XS */
        let x = window.screen.width === 375 && window.screen.height === 812
        /* iPhone XS Max */
        let xsMax = window.screen.width === 414 && window.screen.height === 896
        /* iPhone XR */
        let xR = window.screen.width === 414 && window.screen.height === 896
        if (x || xsMax || xR) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  watch: {
    isShow(data) {
      this.isShowPop = data
      // 解决IOS下-webkit-overflow-scrolling导致z-index失效的问题
      if (env.isIOS) {
        let type = data ? 'auto' : 'touch'
        document.querySelector('.v-page__container>.container') &&
          document
            .querySelector('.v-page__container>.container')
            .setAttribute('style', '-webkit-overflow-scrolling: ' + type)
      }
    }
  },
  data() {
    return {
      isShowPop: this.isShow
    }
  },
  created() {
    if (env.isIOSVivoApp && location.href.includes('/wap/product')) {
      // 覆盖掉组件内的touchmove事件，防止出现iphone手势返回不生效的问题
      const overlayList = document.querySelectorAll('.v-overlay')
      const overlay = overlayList[overlayList.length - 1]

      if (overlay) {
        const cloneNode = overlay.cloneNode(true)
        overlay.parentNode.replaceChild(cloneNode, overlay)
      }
    }
  },
  methods: {
    closeFn() {
      this.isShowPop = false
      this.$emit('close')
    },
    footerClick() {
      this.$emit('footerClick')
    }
  },
  beforeDestroy() {
    this.isShowPop = false
    if (this.container) {
      this.$parent.$el.appendChild(this.$el)
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.popups {
  .container {
    .footer {
      ::v-deep .v-button {
        @include flex-inline-center();
      }
    }
  }
}
</style>
